export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20flowing%20organic%20shapes%20in%20soft%20orange%20and%20gentle%20green%20hues%2C%20minimalist%20modern%20design%2C%20smooth%20curves%2C%20bright%20optimistic%20atmosphere%2C%20clean%20and%20simple%20composition%20with%20subtle%20texture&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 to-accent-600/80"></div>

      <div className="relative z-10 w-full max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-3">
          准备好开始了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-[500px] mx-auto leading-relaxed">
          立即下载黄瓜视频App，加入5000万用户的短视频社区，发现属于你的精彩世界！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#download"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full font-medium text-sm hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-download-line"></i>
            </div>
            免费下载
          </a>
          <a
            href="#faq"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-transparent text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-question-line"></i>
            </div>
            了解更多
          </a>
        </div>
      </div>
    </section>
  );
}